import { render } from "./songsListing.vue?vue&type=template&id=704d3127&scoped=true"
import script from "./songsListing.vue?vue&type=script&lang=js"
export * from "./songsListing.vue?vue&type=script&lang=js"

import "./songsListing.vue?vue&type=style&index=0&id=704d3127&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/gurupadukaweb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-704d3127"]])

export default __exports__